<template>
    <div class="example">
        <div class="example-title">Example {{configuration.component_type_index}}</div>
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'Example',
        props: {
            configuration: Object
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .example
    {
        border-radius: 3px;
        border: 1px solid var(--input-border-color);
        border-top: 3px solid @base;
        background-color: var(--input-background-color);
        padding-top: 30px;
        margin: 50px 0;
        overflow: hidden;

        h2
        {
            font-size: 18px;
            line-height: 24px;
            margin-top: 30px;
        }

        .example-title
        {
            font-size: 13px;
            font-weight: 600;
            color: @base;
            margin: 0 50px 40px;
            text-transform: uppercase;
        }

        .note
        {
            background: fade(@base, 15%);
            padding: 30px 0;

            :first-child
            {
                margin-top: 0;
            }
        }
    }
</style>
